"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return getPathsV3;
    }
});
const _paths = require("./templates/paths");
const _Noco = /*#__PURE__*/ _interop_require_default(require("~/Noco"));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
async function getPathsV3(context, { base, model, columns, views, tableName }, _ncMeta = _Noco.default.ncMeta) {
    const swaggerPaths = await (0, _paths.getModelPaths)(context, {
        baseId: base.id,
        tableName,
        tableId: model.id,
        views,
        type: model.type,
        columns
    });
    return swaggerPaths;
}
